import { Component, OnDestroy, OnInit } from '@angular/core';
import { AccountManagementService } from '../services/account-management.service';
import { NavigationEnd, Router } from '@angular/router';
import { LayoutTypesEnum } from '../../../Common/Layout/enums/layout-types.enum';

@Component({
    selector: 'agpr-account-management',
    templateUrl: './account-management.component.html',
    styleUrls: ['./account-management.component.scss'],
    standalone: false
})
export class AccountManagementComponent implements OnDestroy, OnInit {
    layout = LayoutTypesEnum.horizontal;

    constructor(
        public accountManagementService: AccountManagementService,
        private router: Router,
    ) {
        // For back compatibility with Agility which expects this url format
        // TODO : Remove
        this.router.events.subscribe((e) => {
            if (e instanceof NavigationEnd) {
                const urlParse: RegExp = /AccountManagement\?accountId=(\d+)/;
                const matches = e.urlAfterRedirects.match(urlParse);
                if (matches && matches[1]) {
                    this.router.navigate(
                        ['AccountManagement', 'account', matches[1]]
                    );
                }
            }
        });
    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {

    }
}
